import styled from 'styled-components';
import { container, flexPosition, fontStyle } from '../../../styles/mixins';
import { FONT_WEIGHT_BOLD, GRAY_DARKER } from '../../../styles/variables';

export const RowActions = styled.div`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  ${props =>
    props.numberOfSelected
      ? `
    height: 70px;
    visibility: visible;
  `
      : `
    overflow: hidden;
    height: 0px;
    visibility: hidden;
  `};
  transition: all 500ms ease;
  background-color: #f5f5f5;
`;

export const Content = styled.div`
  ${container()}
  ${flexPosition({ align: 'center' })}
  height: 100%;
  padding: 0 30px;
`;

export const ColActionsLeft = styled.div`
  width: 25%;
  height: 100%;
  padding-left: 15px;
  display: flex;
  align-items: center;
  .checkbox {
    display: flex !important;
  }
  .checkbox-label {
    ${fontStyle(GRAY_DARKER, '15px', FONT_WEIGHT_BOLD)};
    margin-left: 15px;
  }
  label {
    .custom-label {
      margin-left: 0px !important;
    }
  }
`;

export const ColActionsRight = styled.div`
  width: 75%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;



// WEBPACK FOOTER //
// ./src/screens/Product/ProductsGeneralActions/style.js